'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _MenuItem = require('./MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    MenuBody: {
        displayName: 'MenuBody'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Menu/default/MenuBody/MenuBody.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var MenuBody = _wrapComponent('MenuBody')(function (_Component) {
    (0, _inherits3.default)(MenuBody, _Component);

    function MenuBody(props) {
        (0, _classCallCheck3.default)(this, MenuBody);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MenuBody.__proto__ || (0, _getPrototypeOf2.default)(MenuBody)).call(this, props));

        _this.handleClick = function (category) {
            return function (e) {
                e.preventDefault();
                _this.props.onClick_Category(category);
            };
        };

        _this.handleClickDescription = function (category) {
            return function (e) {
                e.preventDefault();
                _this.toggleDescription();
            };
        };

        _this.state = {
            showDescription: false
        };
        return _this;
    }

    (0, _createClass3.default)(MenuBody, [{
        key: 'toggleDescription',
        value: function toggleDescription() {
            this.setState(function (prevState) {
                return { showDescription: !prevState.showDescription };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var category = this.props.category;

            return _react3.default.createElement(
                'li',
                { className: 'dropdown menu-item' },
                _react3.default.createElement(
                    'a',
                    { className: category.children && category.children.length > 0 ? "dropdown-toggle " : "" + "link_underline",
                        href: '#',
                        onClick: this.handleClick(category)
                    },
                    _react3.default.createElement(
                        'div',
                        { style: { display: 'flex' } },
                        _react3.default.createElement(
                            'div',
                            { style: { width: '75%' } },
                            category.title
                        )
                    )
                ),
                category.picture_menu ? _react3.default.createElement(
                    'div',
                    null,
                    _react3.default.createElement('img', { src: category.picture_menu, alt: '', style: { width: '60%' } })
                ) : null,
                this.state.showDescription ? _react3.default.createElement('div', { dangerouslySetInnerHTML: { __html: category.description_menu } }) : null,
                category.children && category.children.length > 0 ? _react3.default.createElement(
                    'ul',
                    { className: 'dropdown-menu drop_box' },
                    _react3.default.createElement(
                        'li',
                        { className: 'yamm-content' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                _react3.default.createElement(
                                    'ul',
                                    null,
                                    category.children.map(function (item, index) {
                                        return _react3.default.createElement(_MenuItem2.default, {
                                            key: index,
                                            category: item,
                                            encapsulate: 0,
                                            onClick_Category: _this2.props.onClick_Category,
                                            openMenu: _this2.props.openMenu,
                                            closeMenu: _this2.props.closeMenu,
                                            toggleMenu: _this2.props.toggleMenu
                                        });
                                    })
                                )
                            )
                        )
                    )
                ) : null,
                category.description_menu ? _react3.default.createElement(
                    'div',
                    { style: {
                            width: '25px',
                            display: 'inline-block',
                            cursor: 'pointer',
                            textAlign: 'center',
                            verticalAlign: 'top',
                            position: 'absolute',
                            top: '5px',
                            left: '75%'
                        },
                        onClick: this.handleClickDescription(category)
                    },
                    _react3.default.createElement('img', { src: '/assets/images/info.svg', alt: '' })
                ) : null
            );
        }
    }]);
    return MenuBody;
}(_react2.Component));

exports.default = MenuBody;
;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Menu/default/MenuBody/MenuBody.jsx
// module id = 1682
// module chunks = 0